export const environment = {
  production: false,
  apiUrl: "https://nv-node-backend-dev-htyabn7jja-el.a.run.app/api",
  encryptapiUrl: "https://krakend-api-gateway-dev-htyabn7jja-el.a.run.app/node-service-dev/api",
  fileuploadUrl: "https://file-upload-framework-dev-htyabn7jja-el.a.run.app/gcs/upload",
  python_url: 'https://pythonservice-dev-htyabn7jja-el.a.run.app',
  php_url: 'https://php-service-dev-htyabn7jja-el.a.run.app',
  php_encryption_url: 'https://krakend-api-gateway-dev-htyabn7jja-el.a.run.app/php-service-dev/android',
  encryptphpurl: 'https://krakend-api-gateway-dev-htyabn7jja-el.a.run.app/php-service-dev',
  useEncryption: 'https://asia-south1-omega-sorter-353009.cloudfunctions.net/dev_krakendConfigToggle',
  env: 'dev'
};
